import { defineFcm } from '../shared/factory';

export const FCM_PRODUCTIZE_SUPER_RECRUITER_FLOW = defineFcm('productize_super_recruiter_flow')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Super recruiter flow',
		description: 'Controls the productize super recruiter flow experiment',
		template: false,
	});
